import { createSlice } from "@reduxjs/toolkit";
const flashMessages = createSlice({
  name:"flashMessages",
  initialState:{
    error:"",
    success:""
  },
  reducers:{
    setError:(state,action)=>{
      state.error = action.payload
    },
    setSuccess:(state,action) => {
      state.success = action.payload
     }
  }
})

export const {setError,setSuccess} = flashMessages.actions
export default flashMessages.reducer